export default "__VITE_ASSET__b832d59d__"